"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fa_1 = require("react-icons/fa");
require("../assets/css/custom-select.css");
var CustomSelect = function (_a) {
    var _b;
    var id = _a.id, name = _a.name, label = _a.label, options = _a.options, value = _a.value, _c = _a.searchable, searchable = _c === void 0 ? true : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.multiple, multiple = _e === void 0 ? false : _e, _f = _a.placeholder, placeholder = _f === void 0 ? "Seçiniz..." : _f, errorMessage = _a.errorMessage, conditionalErrorVisible = _a.conditionalErrorVisible, conditionalErrorMessage = _a.conditionalErrorMessage, tooltip = _a.tooltip, description = _a.description, _g = _a.disabled, disabled = _g === void 0 ? false : _g, className = _a.className, mainClass = _a.mainClass, style = _a.style, mainStyle = _a.mainStyle, submitted = _a.submitted, onChange = _a.onChange;
    var _h = (0, react_1.useState)(""), inputValue = _h[0], setInputValue = _h[1];
    var _j = (0, react_1.useState)(false), dropdownVisible = _j[0], setDropdownVisible = _j[1];
    // Dropdown genişliği için
    var _k = (0, react_1.useState)(undefined), dropdownWidth = _k[0], setDropdownWidth = _k[1];
    var _l = (0, react_1.useState)(false), isInvalid = _l[0], setIsInvalid = _l[1];
    var containerRef = (0, react_1.useRef)(null);
    var currentValues = Array.isArray(value) ? value : [value];
    var selectedValue = Array.isArray(value) ? value[0] : value;
    // Kapsayıcının genişliğini ölç
    (0, react_1.useEffect)(function () {
        var updateDropdownWidth = function () {
            if (containerRef.current) {
                var computedStyle = window.getComputedStyle(containerRef.current);
                var width = containerRef.current.clientWidth -
                    parseFloat(computedStyle.paddingLeft) -
                    parseFloat(computedStyle.paddingRight);
                setDropdownWidth(width);
            }
        };
        updateDropdownWidth();
        window.addEventListener("resize", updateDropdownWidth);
        return function () {
            window.removeEventListener("resize", updateDropdownWidth);
        };
    }, [containerRef.current]);
    // Dış tıklamada dropdown'ı kapat
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            if (containerRef.current &&
                !containerRef.current.contains(event.target)) {
                setDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var toggleValue = function (selectedVal) {
        if (multiple) {
            var newValue = currentValues.includes(selectedVal)
                ? currentValues.filter(function (v) { return v !== selectedVal; })
                : __spreadArray(__spreadArray([], currentValues, true), [selectedVal], false);
            onChange(newValue);
        }
        else {
            onChange(selectedVal);
            setDropdownVisible(false);
        }
        setInputValue("");
    };
    var filteredOptions = options.filter(function (option) {
        return option.label.toLowerCase().includes(inputValue.toLowerCase());
    });
    var handleInvalid = function () {
        setIsInvalid(true);
    };
    var handleInput = function () {
        setIsInvalid(false);
    };
    return (react_1.default.createElement("div", { className: mainClass, style: mainStyle, ref: containerRef },
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement("label", { htmlFor: id, className: "form-label" }, label),
            react_1.default.createElement("div", { className: "select-container form-control ".concat(disabled ? "disabled" : "", " \n    ").concat(submitted
                    ? (Array.isArray(value)
                        ? (value.length > 0 ? "is-valid" : "is-invalid")
                        : (value ? "is-valid" : "is-invalid"))
                    : ""), onClick: function () { return !disabled && setDropdownVisible(!dropdownVisible); }, style: { cursor: disabled ? "not-allowed" : "pointer" } }, multiple ? (currentValues.length > 0 ? (currentValues.map(function (val) {
                var option = options.find(function (opt) { return opt.value === val; });
                return (react_1.default.createElement("span", { key: val, className: "badge bg-primary m-1" },
                    react_1.default.createElement("span", null, option === null || option === void 0 ? void 0 : option.label),
                    react_1.default.createElement(fa_1.FaTimes, { className: "ms-1", style: { cursor: "pointer" }, onClick: function (e) {
                            e.stopPropagation();
                            toggleValue(val);
                        } })));
            })) : (react_1.default.createElement("span", { className: "placeholder" }, placeholder))) : selectedValue ? (react_1.default.createElement("span", { className: "badge bg-primary" },
                react_1.default.createElement("span", null, (_b = options.find(function (opt) { return opt.value === selectedValue; })) === null || _b === void 0 ? void 0 : _b.label))) : (react_1.default.createElement("span", { className: "placeholder" }, placeholder))),
            react_1.default.createElement("input", { type: "text", name: name, value: Array.isArray(value) ? value.join(",") : value, required: required, onInvalid: handleInvalid, onInput: handleInput, style: {
                    position: "absolute",
                    left: "-9999px",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden",
                } }),
            dropdownVisible && (react_1.default.createElement("div", { className: "dropdown-menu show", style: {
                    position: "absolute",
                    zIndex: 10,
                    width: dropdownWidth,
                    overflow: "visible", // Dışa taşmasına izin ver
                } },
                react_1.default.createElement("div", { style: {
                        maxHeight: "200px",
                        overflowY: "auto",
                        //paddingBottom: "40px", // Kapama butonunun yer açması için
                    } },
                    searchable && (react_1.default.createElement("input", { type: "text", placeholder: "Ara...", className: "form-control search-input", value: inputValue, onChange: function (e) { return setInputValue(e.target.value); } })),
                    filteredOptions.length > 0 ? (filteredOptions.map(function (option) { return (react_1.default.createElement("div", { key: option.id, className: "dropdown-item ".concat(currentValues.includes(option.value) ? "selected" : ""), onClick: function () { return toggleValue(option.value); } },
                        currentValues.includes(option.value) && react_1.default.createElement(fa_1.FaCheck, { className: "me-2 text-success" }),
                        option.label)); })) : (react_1.default.createElement("div", { className: "dropdown-item text-muted" }, "Uygun se\u00E7enek yok"))),
                react_1.default.createElement("button", { type: "button", className: "dropdown-close-btn", style: {
                        position: "absolute",
                        bottom: "0",
                        right: "0",
                        transform: "translate(50%, 50%)",
                        border: "none",
                        backgroundColor: "#ccc",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                    }, onClick: function () { return setDropdownVisible(false); } },
                    react_1.default.createElement(fa_1.FaTimes, null)))),
            react_1.default.createElement("div", { className: "invalid-feedback text-danger mt-2" },
                react_1.default.createElement("div", { className: "description-icon" },
                    react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                react_1.default.createElement("div", { className: "description-text" },
                    react_1.default.createElement("span", null, errorMessage || "Lütfen bir seçim yapınız."))),
            conditionalErrorVisible && (react_1.default.createElement("div", { className: "conditional-error-message text-warning mt-2" },
                react_1.default.createElement("div", { className: "description-icon" },
                    react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                react_1.default.createElement("div", { className: "description-text" },
                    react_1.default.createElement("span", null, conditionalErrorMessage)))),
            description && (react_1.default.createElement("div", { className: "form-description text-secondary mt-2" },
                react_1.default.createElement("div", { className: "description-icon" },
                    react_1.default.createElement(fa_1.FaInfoCircle, null)),
                react_1.default.createElement("div", { className: "description-text" },
                    react_1.default.createElement("span", null, description)))))));
};
exports.default = CustomSelect;
